import { IHeaderGroupParams, IProvidedColumn } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AgHeaderExpandComponent } from '@features/ag-header-expand/ag-header-expand.component';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

export interface AgExpandableGroupHeaderParams extends IHeaderGroupParams {
  collapsedByDefault: boolean;
  expandableCols?: string[];
  eyeIconFunction?: () => void;
  eyeIconTooltip?: string;
  filterCols:
    | (() => boolean)
    | ((column: IProvidedColumn, index: number, columns: IProvidedColumn[]) => boolean);
  localStorageKey: string;
  onToggle?: (() => void) | ((params: IHeaderGroupParams) => void);
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TooltipDirective, IconComponent],
  styles: [
    `
      :host {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
      }
    `,
  ],
  template: `
    <div class="flex items-center">
      <span>{{ params.displayName }}</span>
      @if (params.eyeIconFunction) {
        <div
          class="flex cursor-pointer rounded-full p-[4px]"
          [auxTooltip]="params.eyeIconTooltip || ''"
        >
          <aux-icon name="Eye" class="text-aux-blue-dark" (click)="params.eyeIconFunction()" />
        </div>
      }
      <aux-icon
        [name]="visible ? 'ChevronLeft' : 'ChevronRight'"
        class="ml-1 cursor-pointer"
        (click)="toggleExpand()"
      />
    </div>
  `,
})
export class AgExpandableGroupHeaderComponent extends AgHeaderExpandComponent {
  params!: AgExpandableGroupHeaderParams;
  visible = true;

  agInit(params: AgExpandableGroupHeaderParams): void {
    this.params = params;
    this.filterCols = params.filterCols;
    this.visible = !params.collapsedByDefault;
    this.initializeExpandCols();
  }
}
